import { useCallback } from 'react';

import { RunningExperiments, useExperiments } from 'state/experiments';

export enum ReactNativeScreensFreezeExperimentVariants {
  Disabled = 'disabled',
  Enabled = 'enabled',
  EnabledNoTabBlur = 'enabled-no-tab-blur',
}

export const useReactNativeScreensFreezeExperiment = () => {
  const { getVariantValue, logExposure } = useExperiments();
  const variantValue = getVariantValue(RunningExperiments.ReactNativeScreensFreeze)?.value;

  const logExposureWhen = useCallback(
    (variant: ReactNativeScreensFreezeExperimentVariants) => {
      if (variantValue === variant) {
        logExposure(RunningExperiments.ReactNativeScreensFreeze);
      }
    },
    [logExposure, variantValue]
  );

  return { logExposureWhen, freezeVariantValue: variantValue };
};
